
export const AUTHENTICATION_LOGIN = 'AUTHENTICATION_LOGIN'
export const AUTHENTICATION_SUCCESS = 'AUTHENTICATION_SUCCESS'
export const AUTHENTICATION_ERROR = 'AUTHENTICATION_ERROR'
export const AUTHENTICATION_LOGOUT = 'AUTHENTICATION_LOGOUT'
export const AUTHENTICATION_CHECK = 'AUTHENTICATION_CHECK'

export const CHECK_SESSION = "session/check"
export const CHECK_SESSION_SUCCESS = "session/check/SUCCESS"
export const CHECK_SESSION_FAILURE = "session/check/FAILURE"

// ------------------------------------
// Actions
// ------------------------------------

export function authenticationCheck (value) {
  return {
    type    : AUTHENTICATION_CHECK,
    payload : value
  }
}

export function authenticationLogin (value) {
  return {
    type    : AUTHENTICATION_LOGIN,
    payload : value
  }
}

export function authenticationLogout (value) {
  return {
    type    : AUTHENTICATION_LOGOUT,
    payload : value
  }
}

export function handleAuthentication (value) {
  return {
    type    : AUTHENTICATION_SUCCESS,
    payload : value
  }
}

export function handleError (value) {
  return {
    type    : AUTHENTICATION_ERROR,
    payload : value
  }
}

export function checkSession (value) {
  return {
    type: CHECK_SESSION,
    payload: value,
  }
}

export const actions = {
  authenticationCheck,
  authenticationLogin,
  authenticationLogout,
  handleAuthentication,
  handleError,
  checkSession
}



// WEBPACK FOOTER //
// ./src/security/modules/actionsAuth.js